var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSketchPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "111px",
    viewBox: "0 0 124 111",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sketch-plain 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sketch-plain",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.81,110.63 L0.81,40.17 L0.81,39.86 L27.42,4.41 L27.59,4.31 L62,0.7 L96.43,4.31 L96.6,4.41 L123.2,39.85 L123.2,40.16 L62.2,110.62 L61.81,110.63 Z M1.32,40 L62,110.08 L122.68,40 L96.25,4.79 L62,1.2 L27.75,4.79 L1.32,40 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81,110.63 L0.81,40.17 L1,39.75 L25.71,39.75 L25.93,39.89 L62.22,110.35 L61.81,110.63 Z M1.55,40.25 L60.82,108.72 L25.56,40.25 L1.55,40.25 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.19,110.63 L61.78,110.35 L98.07,39.89 L98.29,39.75 L123,39.75 L123.19,40.16 L62.19,110.63 Z M98.45,40.25 L63.18,108.72 L122.45,40.25 L98.45,40.25 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.22,110.58 L61.78,110.58 L25.49,40.11 L25.71,39.75 L98.29,39.75 L98.51,40.11 L62.22,110.58 Z M26.12,40.25 L62,109.92 L97.88,40.25 L26.12,40.25 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.89,40.17 L25.46,40 L27.37,4.56 L27.59,4.33 L62,0.7 L62.21,1.12 L25.89,40.17 Z M27.89,4.78 L26,39.32 L61.36,1.27 L27.89,4.78 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.11,40.17 L61.82,1.17 L62,0.7 L96.38,4.3 L96.6,4.53 L98.54,40 L98.11,40.17 Z M62.64,1.27 L98,39.32 L96.14,4.78 L62.64,1.27 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,40.25 L98.29,40.25 L98,40 L96.13,4.57 L96.58,4.41 L123.2,39.85 L123,40.25 Z M98.53,39.75 L122.53,39.75 L96.68,5.36 L98.53,39.75 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.29,40.25 L25.71,40.25 L25.53,39.83 L61.82,0.83 L62.19,0.83 L98.48,39.83 L98.29,40.25 Z M26.29,39.75 L97.72,39.75 L62,1.32 L26.29,39.75 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.71,40.25 L1,40.25 L0.8,39.85 L27.42,4.41 L27.87,4.57 L26,40 L25.71,40.25 Z M1.5,39.75 L25.5,39.75 L27.35,5.36 L1.5,39.75 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchPlain);
export default __webpack_public_path__ + "static/media/sketch-plain.db2c55880671ce9da5901bd34ceb3244.svg";
export { ForwardRef as ReactComponent };